import { ADD_LOCATION } from '../constants/action-types';
export const addLocation = ({ name, onSubmit }) => ({
    type: ADD_LOCATION,
    payload: {
        name,
        onSubmit,
    },
});
